import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { PostManifestacaoRequest } from '../../requests/orquestrador-dfe/post-manifestacao.request';

@Injectable({
  providedIn: 'root',
})
export class PostManifestacaoService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiOrquestradorDFe}PostManifestacao`;

  public postManifestacao(request: PostManifestacaoRequest): Observable<ReturnStruct> {
    
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
